import React from "react";
import axios from "axios";
import Costanti from "../../constantiX";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column, InputText, Dialog, FileUpload, Toast, RadioButton } from "primereact";
import ReactGA from "react-ga4";
import "../../assets/css/badge.css";
import MultiLanguageDialog from "../MultiLanguageDialog";
import { initValue } from "../../util";

class ListaProcessi extends React.Component {
  constructor() {
    super();
    this.actions = [
      {
        id: 1,
        icon: "pi-search",
        label: "",
        action: (id) => {
          this.vai(id, "V");
          console.log("View " + id);
        },
      },
      {
        id: 2,
        icon: "pi-pencil",
        label: "",
        action: (id) => {
          this.vai(id, "U");
          console.log("Update " + id);
        },
      },
      {
        id: 3,
        icon: "pi-trash",
        label: "",
        action: (id) => {
          this.vai(id, "D");
          console.log("Delete " + id);
        },
      },
    ];
    this.state = {
      activePage: 0,
      lista: [],
      totalRecords: 0,
      first: 0,
      rows: 10,
      loading: true,
      visible1: false,
    };

    this.token = sessionStorage.getItem("ICEtoken");
    this.utente = JSON.parse(sessionStorage.getItem("utente"));
    this.state = {
      xcarica: "sezione",
      processi: [],
      activePage: 1,
      totalRecords: 0,
      pageSize: 10,
      first: 0,
      visible2: false,
      visible3: false,
      singolo: {},
    };
    this.onPage = this.onPage.bind(this);
    this.processoid = 0;
  }

  showMessage(tipo, messageError, dettaglio) {
    var icona = "";
    if (tipo == "error") {
      icona = "pi pi-times-circle";
    }
    if (tipo == "info") {
      icona = "pipi-info-circle";
    }
    if (tipo == "success") {
      icona = "pi pi-check-circle";
    }
    if (tipo == "warning") {
      icona = "pi pi-exclamation-triangle";
    }
    this.toastBC.show({
      severity: tipo,
      life: 3000,
      closable: false,
      content: (
        <div className="flex flex-column" style={{ flex: "1" }}>
          <div className="text-center">
            <i className={icona} style={{ fontSize: "3rem" }}></i>
            <h4>{messageError}</h4>
            <h5>{dettaglio}</h5>
          </div>
        </div>
      ),
    });
  }

  componentDidMount() {
    //alert(this.props.location.pathname);
    //ReactGA.send({ hitType: "pageview", page: this.props.location.pathname });
    this.aziendaid = this.utente.aziendaid;
    this.caricaDati(1, this.state.pageSize);
  }

  caricaDati(pagina, numrec) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ loading: true });
    var quer = "page=" + pagina + "&num=" + numrec + "&aziendaid=" + this.aziendaid;
    axios
      .get(Costanti.UrlCallApi + "processo/all?" + quer, config)
      .then((res) => {
        res.data.lista1.forEach((element) => {
          element.azioni = this.actions;
        });
        const rowItemVal = [];
        const traduzioneArray = res.data.lista1.map((item) => item.traduzione);
        const processiIdAndNameArray = res.data.lista1.map((item) => ({
          id: item.id,
          codiceesterno: item.codiceesterno,
        }));

        traduzioneArray.forEach((el, index) => {
          const filteredValue = el.filter((item) => item.lingua === "it");
          const nome = filteredValue.find((item) => item.nomecampo === "nome");
          const descrizione = filteredValue.find((item) => item.nomecampo !== "nome");
          const fieldValue = {
            nome: nome ? nome.testo : "",
            descrizione: descrizione ? descrizione.testo : "",
            id: processiIdAndNameArray[index].id,
            codiceesterno: processiIdAndNameArray[index].codiceesterno,
          };
          rowItemVal.push(fieldValue);
        });
        this.setState({
          processi: rowItemVal.length > 0 ? rowItemVal : undefined,
          totalRecords: res.data.conta1,
          loading: false,
        });

        //alert(JSON.stringify(this.state.prodotti))
      })
      .catch((error) => {
        alert(error);
      });
  }

  caricaSingolo(id, tipo) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ loading: true });
    axios
      .get(Costanti.UrlCallApi + "processo/" + id, config)
      .then((res) => {
        this.setState({ singolo: res.data, loading: false });
      })
      .catch((error) => {
        this.processoid = 0;
        alert(error);
      });
  }

  setVisible1(val) {
    this.setState({ visible1: val });
    this.caricaDati(this.state.activePage, this.state.pageSize);
  }

  vai(id, tipo) {
    this.caricaSingolo(id);
    this.setVisible1(true);
    this.setState({ tipo: tipo });
    switch (tipo) {
      case "A":
        this.setState({ editMode: true, singolo: {}, intestazione: "Aggiungi Processo" });
        break;
      case "V":
        this.setState({ intestazione: "Visualizza Processo" });
        break;
      case "D":
        this.setState({ intestazione: "Elimina Processo" });
        break;
      case "U":
        this.setState({ editMode: true, intestazione: "Modifica Processo" });
        break;
    }
  }
  onPage(event) {
    this.setState({
      loading: true,
      activePage: event.page + 1,
      first: event.first,
    });
    this.caricaDati(event.page + 1, this.state.pageSize);
  }

  setPDF(value) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    axios
      .get(Costanti.UrlCallApi + "stampe/processi/" + this.aziendaid, config)
      .then((res) => {
        const link = document.createElement("a");
        const url = Costanti.UrlCallApi + "file/getFile/" + res.data;

        link.href = url;
        link.setAttribute("download", res.data);
        // Append to html link element page
        document.body.appendChild(link);
        // Start download
        link.click();
        // Clean up and remove the link
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        this.showMessage("error", "Errore nella stampa", error.message);
        this.setState({ isSubmitting: false });
      });
  }


  render() {
    return (
      <div>
        <Toast ref={(el) => (this.toastBC = el)} position="bottom-center" />

        <Dialog
          header="PDF"
          closable={false}
          visible={this.state.viewPDF}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <footer>
            <div className="border-top-1 surface-border pt-3">
              <Button type="button" icon="pi pi-check" onClick={() => this.setPDF(false)} label="Chiudi" />
            </div>
          </footer>
        </Dialog>

        <Dialog
          header="PDF"
          closable={false}
          visible={this.state.viewPDF}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <footer>
            <div className="border-top-1 surface-border pt-3">
              <Button type="button" icon="pi pi-check" onClick={() => this.setPDF(false)} label="Chiudi" />
            </div>
          </footer>
        </Dialog>

        <DataTable
          value={this.state.processi}
          rows={this.state.pageSize}
          totalRecords={this.state.totalRecords}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="	(pag. {currentPage} di {totalPages}) "
          paginator={true}
          onPage={this.onPage}
          loading={this.state.loading}
          lazy={true}
          first={this.state.first}
          header={
            <div className="mb-1 flex align-items-center justify-content-between">
              <span className="text-xl font-medium text-900">Lista Processi</span>
              <InputText type="search" className="border-none" placeholder="Cerca..." />
      
              <Button
                label="Esporta in Pdf"
                onClick={() => this.setPDF(true)}
                icon="pi pi-file-pdf"
                className="p-button-rounded p-button-danger "
              />
              <Button
                label="Aggiungi"
                onClick={() => this.vai(0, "A")}
                icon="pi pi-plus"
                className="p-button-rounded p-button-primary "
              />
            </div>
          }
          responsiveLayout="stack"
        >
          <Column
            id="id0"
            header=""
            body={(item) =>
              item.hasImage != null && item.hasImage.startsWith("video") ? (
                <video width="100" height="100" controls autoPlay muted={true}>
                  <source
                    src={
                      Costanti.UrlCallApi +
                      "file/get/" +
                      this.utente.aziendaid +
                      "/processo/" +
                      item.id +
                      "?" +
                      Math.random()
                    }
                    alt=""
                  />
                </video>
              ) : (
                <img
                  src={
                    Costanti.UrlCallApi +
                    "file/get/" +
                    this.utente.aziendaid +
                    "/processo/" +
                    item.id +
                    "?" +
                    Math.random()
                  }
                  className="w-full"
                  style={{ maxWidth: "100px", maxHeight: "px" }}
                  alt=""
                />
              )
            }
          />
          <Column id="id1" field="codiceesterno" header="Codice" />
          <Column id="id2a" field="nome" header="Nome" />
          <Column id="id2b" field="descrizione" header="Descrizione" style={{ width: 400 }} />

          <Column
            id="id5"
            field="id"
            header="Azioni"
            body={(item) => (
              <div className="product-list-action flex" style={{ alignItems: "center", gap: "1rem" }}>
                {this.actions.map((action) => (
                  <Button
                    key={action.id}
                    className="p-button-sm"
                    icon={`pi ${action.icon}`}
                    label={action.label}
                    aria-label={action.label}
                    onClick={(e) => {
                      e.stopPropagation();
                      action.action(item.id);
                    }}
                  />
                ))}
              </div>
            )}
          ></Column>
        </DataTable>

        {((this.state.singolo && Object.keys(this.state.singolo).length > 0) || this.state.tipo === "A") && (
          <MultiLanguageDialog
            hasImage={true}
            title={this.state.intestazione}
            isVisible={this.state.visible1}
            operationType={this.state.tipo}
            itemId={this.state.singolo.id}
            contents={this.state.singolo}
            initValue={initValue}
            onClose={() => this.setVisible1(false)}
            label={["Nome", "Descrizione"]}
            itemToAdd={{
              datains: null,
              dataupd: null,
              id: 0,
              aziendaid: this.aziendaid,
              uteins: 1,
              uteupd: null,
              status: " ",
            }}
            inputTextComp={{ name: "codiceesterno", label: "Codice" }}
            table={"processo"}
          />
        )}
      </div>
    );
  }
}

export default ListaProcessi;
